import { render, staticRenderFns } from "./LabelCategorySettingsOverview.vue?vue&type=template&id=29738afb&"
import script from "./LabelCategorySettingsOverview.vue?vue&type=script&lang=js&"
export * from "./LabelCategorySettingsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports